import {styled} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import {useEffect, useState} from 'react';

import {localStorageKey} from 'core/constants';
import {isCypressApp} from 'core/utils/cypress';
import {dayjs, isToday} from 'utils/dateUtils';

import EnnablAIIcon from 'components/icons/ennablAI.svg';

import {
  DecisionsDialog,
  DecisionsDialogActions,
  DecisionsDialogContent,
  PrimaryActionButton,
} from 'modules/decisionsNext/components/DecisionsDialog';

const ENNABL_AI_LINK = 'https://ennabl.ai/';

// Stop showing the promo after this date (one week after release).
const endDate = dayjs('2026-06-12').endOf('day');

const SContent = styled('div')(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
}));

const SEnnablAIIcon = styled(EnnablAIIcon)(({theme}) => ({
  alignSelf: 'center',
  marginBottom: theme.spacing(2),
}));

export const EnnablAIPromoDialog = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const lastShown = localStorage.getItem(localStorageKey.EnnablAIPromo);
    const shownToday = !!lastShown && isToday(lastShown);

    if (dayjs().isBefore(endDate) && !shownToday) {
      setOpen(true);
      localStorage.setItem(localStorageKey.EnnablAIPromo, dayjs().toISOString());
    }
  }, []);

  const handleClose = () => setOpen(false);

  const handleTryNow = () => {
    window.open(ENNABL_AI_LINK, '_blank', 'noopener,noreferrer');
    handleClose();
  };

  if (isCypressApp()) {
    return null;
  }

  return (
    <DecisionsDialog open={open} title="We've launched" onClose={handleClose}>
      <DecisionsDialogContent>
        <SContent>
          <SEnnablAIIcon height={40} />

          <Typography variant='body2'>Our AI-native platform built for insurance brokers and agents.</Typography>

          <Typography variant='body2'>
            Automate repeatable workflows for document comparison, proposal generation, and insurance summarization.
          </Typography>
        </SContent>
      </DecisionsDialogContent>

      <DecisionsDialogActions
        primaryAction={<PrimaryActionButton onClick={handleTryNow}>Try it Now</PrimaryActionButton>}
      />
    </DecisionsDialog>
  );
};
